import {Component} from '@angular/core';
import {filter,finalize,first} from "rxjs/operators";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {ConfirmService} from '@share/component/confirmation/confirm.service';
import {TranslateService} from '@ngx-translate/core';
import {PleaseWaitService} from '@share/component/please-wait/please-wait.service';
import {EntrepriseVehiculesService} from '../../entreprise-vehicules.service';
import {ToastrService} from 'ngx-toastr';
import {Result,TypeCodeErreur} from '@domain/common/http/result';
import {PuissanceFiscale} from "@domain/admin/entreprise/vehicules/puissanceFiscale";

/**
 * Item de la liste des puissances fiscales
 */
@Component({
    host: {'data-test-id': 'puissance-fiscale-list-item'},
    templateUrl: './puissance-fiscale-list-item.component.html'
})
export class PuissanceFiscaleListItemComponent extends ListViewItem<PuissanceFiscale> {
    /** Surcharge pour typage des options */
    extraOptions: { openPuissance: (puissance?: PuissanceFiscale) => void };

    /**
     * Constructeur
     *
     * @param confirmService Service de confirmation
     * @param translateService Service des traductions
     * @param pleaseWaitService Service d'affichage du loading
     * @param vehiculeService Service des véhicules
     * @param toastrService Service des toasts
     */
    constructor(private confirmService: ConfirmService,
                private translateService: TranslateService,
                private pleaseWaitService: PleaseWaitService,
                private vehiculeService: EntrepriseVehiculesService,
                private toastrService: ToastrService) {
        super();
    }

    /**
     * Suppression de la puissance fiscale
     */
    deletePuissance(): void {
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe(() => {
                //Ouverture de la modale de chargement
                let waitDialogRef = this.pleaseWaitService.show();

                //Suppression puis fermeture de la modale de chargement
                this.vehiculeService.deletePuissance(this.data.idPuissance)
                    .pipe(first(), finalize(() => waitDialogRef.close()))
                    .subscribe((result: Result) => {
                        if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                            //Message d'information
                            this.toastrService.success(this.translateService.instant('global.success.suppression'));

                            //Rechargement de la liste
                            this.liste.refresh();
                        } else {
                            //Message d'erreur
                            TypeCodeErreur.showError(result.codeErreur,this.translateService,this.toastrService);
                        }
                    });
            });
    }

}
